/* eslint-disable  no-shadow */

import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import ReactLoading from 'react-loading'
import moment from 'moment'
import { get } from 'lodash'
import { ModalHeader } from 'Stories/ModalHeader/ModalHeader.stories'
import { DottedBtn } from 'Stories/DottedBtn/DottedBtn.stories'
import { GreenBtn, RedBtn } from 'Stories/Button/Button.stories'
import { Modal } from 'antd'

import PlaylistChartAdmin from '../PlaylistChartAdmin'
import AutoSelectedGenres from '../AutoSelectedGenres'
import PlaylistSfaData from '../PlaylistSfaData'

import { PlaylistDetailsModalProps } from './PlaylistDetailsModalProps'

import {
  TitleDetails,
  ModalBody,
  ModalBodySmall,
  ModalBodyTitle,
  ModalBodyTitleImg,
  ModalBodyTitleText,
  ModalBodyTitleTextName,
  ModalBodyTitleTextBy,
  DetailsList,
  DetailsItem,
  DiscoveredOnWrapper,
  WrapperForStatus,
  DetailsItemTitle,
  DetailsItemLink,
  DetailsItemInfo,
  DetailsItemInfoNegative,
  DetailsItemInfoStatus,
  DetailsItemInfoSecondary,
  SFAData,
  SFADataTitle,
  ModalFooter,
  ButtonWrapper,
  ShowDetailsWrapper,
  List,
  Th,
} from './styles'

const PlaylistDetailsModal: FunctionComponent<PlaylistDetailsModalProps> = ({
  toggle,
  modal,
  isError,
  errorMessage,
  isSubmitSuccessful,
  isLoading,
  item,
  status,
  activatePlaylist,
  deactivatePlaylist,
  handleRefreshDiscoveredOn,
  detailShow,
  setDetailsShow,
}) => {
  const { t } = useTranslation()

  const handleShowDetails = () => {
    !detailShow ? setDetailsShow(true) : setDetailsShow(false)
  }

  const selectedGenresByCurator = get(item.playlist, 'genres_name', null)
  const mappedSelectedGenresByCurator =
    selectedGenresByCurator &&
    selectedGenresByCurator.map((item, index, arr) => (
      <li key={item}>
        {item.slice(0, 1).toUpperCase() + item.slice(1)}
        {index + 1 !== arr.length && ',\u00A0'}
      </li>
    ))

  const targetLanguage = get(item.playlist, 'languages_name', null)
  const mappedTargetLanguage =
    targetLanguage &&
    targetLanguage.map((item, index, arr) => (
      <li key={item}>
        {item.slice(0, 1).toUpperCase() + item.slice(1)}
        {index + 1 !== arr.length && ',\u00A0'}
      </li>
    ))

  return (
    <>
      {item.playlist && item.curator && (
        <Modal
          width={600}
          className="modal-dialog--success modal-dialog--header playlist"
          visible={modal}
          footer={null}
          closeIcon={
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              onClick={toggle}
            />
          }
          onCancel={() => toggle()}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              onClick={toggle}
            />

            <ModalHeader content={t('adminPage.playlistDetails')} />
          </div>
          {!isLoading && !isError && !isSubmitSuccessful && (
            <>
              <ModalBody>
                <ModalBodyTitle>
                  <ModalBodyTitleImg>
                    <img alt="cover" src={item.playlist.playlist_cover} />
                  </ModalBodyTitleImg>
                  <ModalBodyTitleText>
                    <ModalBodyTitleTextName
                      href={`https://open.spotify.com/playlist/${item.playlist.playlist_url.slice(
                        -22
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.playlist.playlist_name}
                    </ModalBodyTitleTextName>

                    <ModalBodyTitleTextBy>
                      {t('adminPage.by')} {item.curator.email}
                    </ModalBodyTitleTextBy>
                  </ModalBodyTitleText>
                </ModalBodyTitle>

                <>
                  <TitleDetails>{t('adminPage.details')}</TitleDetails>
                  <DetailsList>
                    <DetailsItem>
                      <DetailsItemTitle>
                        {t('adminPage.profileName')}
                      </DetailsItemTitle>

                      <DetailsItemLink
                        href={`https://open.spotify.com/user/${item.curator.spotify_id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item.curator.first_name} {item.curator.last_name}
                      </DetailsItemLink>
                    </DetailsItem>

                    <DetailsItem>
                      <DetailsItemTitle>
                        {t('adminPage.otherPlaylistFollowers')}
                      </DetailsItemTitle>
                      <DetailsItemInfo>
                        {item.playlistsFollowers &&
                          item.playlistsFollowers.join(', ')}
                      </DetailsItemInfo>
                    </DetailsItem>
                    <DetailsItem>
                      <DetailsItemTitle>
                        {t('adminPage.discoveredON')}
                      </DetailsItemTitle>
                      <DetailsItemInfo>
                        {item.playlist.discovered_on_artists &&
                          item.playlist.discovered_on_artists}
                        /30 {t('adminPage.lastUpdate')}{' '}
                        {item.playlist.discovered_on_updated_at
                          ? moment(
                              item.playlist.discovered_on_updated_at
                            ).format('l')
                          : 'Need to update'}
                      </DetailsItemInfo>
                    </DetailsItem>
                    <DetailsItem>
                      <DiscoveredOnWrapper>
                        <DottedBtn
                          content={t('adminPage.refreshDiscoveredON')}
                          onClick={() =>
                            handleRefreshDiscoveredOn(item.playlist.id)
                          }
                        />
                      </DiscoveredOnWrapper>
                    </DetailsItem>
                    <DetailsItem>
                      <DetailsItemTitle>
                        {t('adminPage.negativeResponse')}
                      </DetailsItemTitle>
                      <DetailsItemInfoNegative>
                        {item.negativeResponses && item.negativeResponses}
                      </DetailsItemInfoNegative>
                    </DetailsItem>
                    <DetailsItem>
                      <DetailsItemTitle>
                        {t('adminPage.addingRate')}
                      </DetailsItemTitle>
                      <DetailsItemInfo>
                        {item.addingRate && item.addingRate
                          ? item.addingRate.toFixed(2)
                          : 0}
                        %
                      </DetailsItemInfo>
                    </DetailsItem>
                    <WrapperForStatus>
                      <DetailsItem>
                        <DetailsItemTitle>
                          {t('adminPage.status')}
                        </DetailsItemTitle>
                        <DetailsItemInfoStatus>
                          {status && status}
                        </DetailsItemInfoStatus>
                        <DetailsItemInfoSecondary>
                          {item.playlist_status_spotify &&
                            `(${item.playlist_status_spotify})`}
                        </DetailsItemInfoSecondary>
                      </DetailsItem>
                    </WrapperForStatus>
                    <DetailsItem>
                      <DetailsItemTitle>
                        {t('adminPage.genresAutoselected')}
                      </DetailsItemTitle>
                      <DetailsItemInfo>
                        <AutoSelectedGenres
                          autoSelectedGenres={item.autoSelectedGenres}
                        />
                      </DetailsItemInfo>
                    </DetailsItem>
                    <DetailsItem>
                      <DetailsItemTitle>
                        {t('adminPage.genresSelectedByCurator')}
                      </DetailsItemTitle>
                      <DetailsItemInfo>
                        <List>{mappedSelectedGenresByCurator}</List>
                      </DetailsItemInfo>
                    </DetailsItem>
                    <DetailsItem>
                      <DetailsItemTitle>
                        {t('adminPage.targetLanguage')}
                      </DetailsItemTitle>
                      <DetailsItemInfo>
                        <List>{mappedTargetLanguage}</List>
                      </DetailsItemInfo>
                    </DetailsItem>
                  </DetailsList>
                  <SFAData>
                    <SFADataTitle>{t('adminPage.SFAData')}</SFADataTitle>
                    <DottedBtn
                      content={
                        detailShow
                          ? t('adminPage.hideDetails')
                          : t('adminPage.showDetails')
                      }
                      onClick={handleShowDetails}
                    />
                  </SFAData>
                  {detailShow && (
                    <ShowDetailsWrapper>
                      <tr>
                        <Th />
                        <Th>{t('adminPage.listeners')}</Th>
                        <Th>{t('adminPage.streams')}</Th>
                      </tr>

                      <PlaylistSfaData playlistSfaData={item.playlistSfaData} />
                    </ShowDetailsWrapper>
                  )}
                  <PlaylistChartAdmin followersData={item.followersData} />
                </>
              </ModalBody>

              <ModalFooter>
                <ButtonWrapper>
                  {item.playlist.status === 'on_review' && (
                    <>
                      <GreenBtn
                        color="green"
                        onClick={() => activatePlaylist(item.playlist.id)}
                      >
                        {t('adminPage.activatePlaylist')}
                      </GreenBtn>

                      <RedBtn
                        color="red"
                        onClick={() => deactivatePlaylist(item.playlist.id)}
                      >
                        {t('adminPage.deactivatePlaylist')}
                      </RedBtn>
                    </>
                  )}
                  {item.playlist.status === 'activated' && (
                    <RedBtn
                      color="red"
                      onClick={() => deactivatePlaylist(item.playlist.id)}
                    >
                      {t('adminPage.deactivatePlaylist')}
                    </RedBtn>
                  )}
                  {item.playlist.status === 'deactivated' && (
                    <GreenBtn
                      color="green"
                      onClick={() => activatePlaylist(item.playlist.id)}
                    >
                      {t('adminPage.activatePlaylist')}
                    </GreenBtn>
                  )}
                </ButtonWrapper>
              </ModalFooter>
            </>
          )}
          {isLoading && (
            <ReactLoading
              className="users-loading loading"
              height={24}
              type="spinningBubbles"
            />
          )}
          {isError && !isLoading && (
            <>
              <ModalBodySmall>{errorMessage}</ModalBodySmall>
            </>
          )}
          {isSubmitSuccessful && (
            <ModalBodySmall>
              {t('adminPage.submissionSuccessful')}
            </ModalBodySmall>
          )}
        </Modal>
      )}
    </>
  )
}

export default PlaylistDetailsModal
